(function() {
    'use strict';

    angular
        .module('gestioneAttiApp')
        .factory('SedutaPubblica', SedutaPubblica);

    SedutaPubblica.$inject = ['$resource', 'DateUtils'];

    function SedutaPubblica($resource, DateUtils) {

        var resourceUrl = 'api/public/sedute';

        return $resource(resourceUrl, {}, {

            'query': { 
                method: 'GET', 
                isArray: true,
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                        angular.forEach(data, function(seduta) {
                            seduta.dataSeduta = DateUtils.convertDateTimeFromServer(seduta.dataSeduta);
                        });
                    }
                    return data;
                }
            },

            'getDettagliCommissione': {
                url: 'api/public/commissiones/:idCommissione',
                method: 'GET'
            },

            'getDettagliSoggettoEsterno': {
                url: 'api/public/soggetto-esternos/:idSoggettoEsterno',
                method: 'GET'
            }
        });
    }
})();
